(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-panel-tipsen/assets/javascripts/sport-event.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-panel-tipsen/assets/javascripts/sport-event.js');
"use strict";

const {
  ForEach
} = svs.components.lbUtils.reactConditionals;
const {
  Participant
} = svs.components.tipsen.drawPanelTipsen;
const SportEvent = _ref => {
  let {
    sportEventData,
    additionalEventsCount
  } = _ref;
  const {
    participants: participantsIds
  } = sportEventData;
  return React.createElement("ul", {
    className: "sport-event"
  }, React.createElement(ForEach, {
    array: participantsIds,
    render: (participantId, index) => React.createElement(Participant, {
      additionalEventsCount: additionalEventsCount,
      index: index,
      key: participantId,
      participantId: participantId
    })
  }));
};
setGlobal('svs.components.tipsen.drawPanelTipsen.SportEvent', SportEvent);

 })(window);